import { render, staticRenderFns } from "./Chipcards.vue?vue&type=template&id=a88e2d5c&scoped=true"
import script from "./Chipcards.vue?vue&type=script&lang=ts"
export * from "./Chipcards.vue?vue&type=script&lang=ts"
import style0 from "./Chipcards.vue?vue&type=style&index=0&id=a88e2d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88e2d5c",
  null
  
)

export default component.exports